import { MatSnackBar } from '@angular/material/snack-bar';
//import { FooternotificationComponent } from '../components/footernotification/footernotification.component';

export class NotificationService {
    showWarning(arg0: string) {
      throw new Error('Method not implemented.');
    }
    showSuccess(arg0: string) {
      throw new Error('Method not implemented.');
    }
    showError(arg0: string) {
      throw new Error('Method not implemented.');
    }
    snackBarShown = false;
    verticalPosition: any = "top";
    horizontalPosition: any = "center";
    duration: number = 5000;
    direction: any = "ltr";
    action: string = "Ok";
  
    verticalPositionBottom: any = "bottom";
    horizontalPositionBottom: any = "center";
    directionBottom: any = "ltr";
    actionBottom: string = "Close";
  
    constructor(public snackBar: MatSnackBar) { }
  
    showNotification(message: string,duration:number=5000) {
      this.snackBar.open(message, this.action, { duration: duration, verticalPosition: this.verticalPosition, horizontalPosition: this.horizontalPosition, direction: this.direction });
      this.resetParams();
    }
  
    resetParams() {
      this.verticalPosition = "top";
      this.horizontalPosition = "center";
      this.duration = 5000;
      this.direction = "ltr";
      this.action = "Ok";
    }
  
    showNotificationBottom(message: string) {
      this.snackBar.open(message, this.actionBottom, { verticalPosition: this.verticalPositionBottom, horizontalPosition: this.horizontalPositionBottom, direction: this.directionBottom });
    }
  
  
    openSnackBar(message: string) {
      this.snackBarShown = true;
      //this.snackBar.openFromComponent(FooternotificationComponent, { verticalPosition: this.verticalPosition, panelClass: ['mat-elevation-z3'], data: message });
    }
    closeSnackBar() {
      this.snackBarShown = false;
      this.snackBar.dismiss();
    }
  
    closeNotification() {
      this.snackBar.dismiss();
    }
  }